import { LabelLangString } from "component/LabelLang/label-lang";
import Linkable from "component/LinkableComponent/linkable-component";
import { API_BASE_URL } from "configs/AppConfig";
import { DateFormater } from "functions/dateTimeFormat";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

const NewsTitleCard = ({ name, id = 1, translations }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="news-card browsetopic-item">
      <Row>
        <Col xs={12} md={7} lg={9} xl={10} className="img-details">
          <Linkable link={`mediaLanding/news/${id}`}>
            <div className="text-black">
              {LabelLangString({
                id: "name",
                currentLocale: currentLocale,
                defaultValue: name,
                translations: translations,
              })}
            </div>
          </Linkable>
          <div className="row-r mt-0" style={{ marginInlineEnd: "-21%" }}>
            <Linkable
              link={`mediaLanding/news/${id}`}
              className="main-btn more-item"
            >
              <span>
                <FormattedMessage id="more" />
              </span>
              <i className="fas fa-ellipsis-h"> </i>
            </Linkable>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NewsTitleCard;
